import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <footer className="w-full bg-teal text-white" data-id="element-76" data-mp="3ucndvrnypfti">
      <div className="mx-auto max-w-4xl px-5 py-20 text-center" data-id="element-77" data-mp="3udyj7vx22vmq">
        <p className="font-display text-3xl font-bold leading-tight md:text-5xl" data-id="element-78" data-mp="c70z1dii1lq5">
          You can keep the same screen routine as always… or give them a real, creative space to build{' '}
          <span className="text-sun" data-id="element-79" data-mp="m4f1g97l89zg">childhood memories.</span>
        </p>
        <CTAButton className="mt-10" data-id="element-80" data-mp="m2lx50kg61um">Yes, I want instant access!</CTAButton>
        <p className="mt-5 text-sm font-bold text-white/85" data-id="element-81" data-mp="h5loqj04kn0c">Instant digital delivery · Lifetime access · 100% digital</p>
      </div>
      <div className="border-t border-white/15" data-id="element-82" data-mp="qvotfgglzpei">
        <p className="mx-auto max-w-6xl px-5 py-6 text-center text-sm text-white/75" data-id="element-83" data-mp="qwzwfe28ct4k">
          © {new Date().getFullYear()} Curious Mind Hub · Maker Lab™. All rights reserved.
        </p>
      </div>
    </footer>;
}